// extracted by mini-css-extract-plugin
export default {"header":"signupHeader_header__iIBEK","col":"signupHeader_col__fLRBT"};